import React from 'react';
import { classNames, Title, Bold } from '@panwds/react-ui';

const BOTTOM_MARGIN = 10;
function FlyOutMenu({ title, menuRef, children, isSimpleNav, onMouseOver, onMouseOut, }) {
    var _a;
    const menuRefs = (_a = menuRef === null || menuRef === void 0 ? void 0 : menuRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    const rootClasses = "tw-box-border tw-bg-blue-steel-1000 dark:tw-bg-black tw-rounded tw-absolute tw-left-18 tw-top-10 tw-overflow-x-hidden tw-overflow-y-auto tw-scrollbar-small tw-scrollbar-no-track dark:tw-scrollbar-thumb-dark dark:tw-scrollbar-corner-dark tw-w-56";
    const ulClasses = classNames("tw-box-border tw-list-none tw-m-0 tw-p-0 tw-b-0 tw-py-2", title && "tw-py-0", isSimpleNav &&
        "tw-ml-2 tw-border-solid tw-border-b-0 tw-border-r-0 tw-border-l-0 tw-border-t tw-border-blue-steel-800 dark:tw-border-gray-950");
    return (React.createElement("div", { "data-testid": "flyout", style: {
            top: menuRefs === null || menuRefs === void 0 ? void 0 : menuRefs.top,
            maxHeight: `${window.innerHeight - BOTTOM_MARGIN - ((menuRefs === null || menuRefs === void 0 ? void 0 : menuRefs.top) || 0)}px`,
        }, onMouseOver: onMouseOver, onMouseOut: onMouseOut, className: rootClasses },
        title && (React.createElement(Title, { level: 3, size: "xxs", addClassName: "tw-h-10 tw-text-dark-bg tw-ml-2 tw-px-2 tw-py-2 tw-box-border", truncate: true },
            React.createElement(Bold, null, title))),
        React.createElement("ul", { className: ulClasses }, children)));
}

export { FlyOutMenu };
//# sourceMappingURL=FlyOutMenu.esm.js.map
